import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'atx-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalHeaderComponent {
  @Input()
  public titleClass: string;

  @Input()
  public showCloseBtn = true;

  @Output()
  public dismiss: EventEmitter<void> = new EventEmitter();

  @HostBinding('class.modal-header')
  public modalHeaderClass = true;
}
